export const userGroups = () => {
  const groups = sessionStorage.getItem("mwerezi_mpos_usergroups");
  const groups_array = groups !== "undefined" ? JSON.parse(groups) : [];
  return groups_array;
};
